import { render, staticRenderFns } from "./PartialLoading.vue?vue&type=template&id=60a035c2&scoped=true&"
import script from "./PartialLoading.vue?vue&type=script&lang=js&"
export * from "./PartialLoading.vue?vue&type=script&lang=js&"
import style0 from "./PartialLoading.vue?vue&type=style&index=0&id=60a035c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a035c2",
  null
  
)

component.options.__file = "PartialLoading.vue"
export default component.exports